module.exports = __webpack_public_path__ + "img/commodity4.4eeae268.png";